import { useTranslation } from "react-i18next";
import { AlertTriangle } from "lucide-react";
import { isApiError } from "../lib/api";

export function errorMessage(e: unknown, fallback: string): string {
  if (isApiError(e)) return e.message + (e.requestId ? ` (${e.requestId})` : "");
  if (e instanceof Error) return e.message;
  return fallback;
}

export function ErrorBanner({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div role="alert" className="flex items-center gap-2 rounded-md border border-danger bg-danger-bg px-3 py-2 text-sm text-danger">
      <AlertTriangle size={16} aria-hidden />
      <span className="flex-1">{errorMessage(error, t("common.error"))}</span>
      {onRetry && (
        <button type="button" className="btn" onClick={onRetry}>
          {t("common.retry")}
        </button>
      )}
    </div>
  );
}
